import { render } from "./PaginatorComponent.vue?vue&type=template&id=4d0a528c&ts=true"
import script from "./PaginatorComponent.vue?vue&type=script&lang=ts"
export * from "./PaginatorComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__